import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import SageScreen from "kit/SageScreen";
import React from "react";
import { useSelector } from "react-redux";
import createOrderStatusSelector from "selectors/createOrderStatus";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";
import { centHundredthsToString } from "utils/moneyFormat";
import BalanceMinutesOrderForm from "./balanceMinutesOrder/BalanceMinutesOrderForm";
import BalanceMinutesOrderSuccess from "./balanceMinutesOrder/BalanceMinutesOrderSuccess";

const BalanceMinutesOrder: React.FC = () => {
    const [user] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    const createOrderStatus = useSelector(createOrderStatusSelector);

    return (
        <SageScreen>
            <h2>Order Minutes</h2>
            <p>
                Your Current Money Balance:{" "}
                {user ? (
                    <span className="text-primary">
                        {centHundredthsToString(
                            user.money_balance_cent_hundredths
                        )}
                    </span>
                ) : (
                    "loading"
                )}
            </p>
            {createOrderStatus === "success" ? (
                <BalanceMinutesOrderSuccess />
            ) : (
                <BalanceMinutesOrderForm />
            )}
        </SageScreen>
    );
};

export default BalanceMinutesOrder;
